export default [
  {
    path: '/reports/turnover',
    name: 'turnover-report',
    component: () => import('../pages/reports/turnover/turnover-report.shell.vue'),
  },
  {
    path: '/reports/forecast',
    name: 'forecast-report',
    component: () => import('../pages/reports/forecast/forecast-report.shell.vue'),
  },
  {
    path: '/reports/cancellation',
    name: 'cancellation-report',
    component: () => import('../pages/reports/cancellation/cancellation.shell.vue'),
  },
  {
    path: '/reports/hotel-sales',
    name: 'hotel-sales-report',
    component: () => import('../pages/reports/hotel-sales/hotel-sales-report.shell.vue'),
  },
  {
    path: '/reports/hotel-turnover',
    name: 'hotel-turnover-report',
    component: () => import('../pages/reports/hotel-turnover/hotel-turnover-report.shell.vue'),
  },
  {
    path: '/reports/company-turnover',
    name: 'company-turnover-report',
    component: () => import('../pages/reports/company-turnover/company-turnover-report.shell.vue'),
  },
];
